import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { UiEarthOutlineIcon } from "@jti/brand-icons/ui-earth-outline";
import { Button } from "@jti/ui";
export const LanguageSelectorButton = ({ toggleDropdown, languageName }) => {
    return (_jsxs(Button, { onClick: toggleDropdown, size: "medium", color: "secondary", children: [_jsx(UiEarthOutlineIcon, { width: 20, height: 20 }), languageName] }));
};
//# sourceMappingURL=LanguageSelectorButton.js.map